import { VideoProvider } from "@/constants";

// Matches youtube.com/watch?v=ID, youtu.be/ID, /embed/ID, /shorts/ID, /live/ID
const YOUTUBE_ID_PATTERN =
  /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([\w-]{11})/;
// Matches vimeo.com/ID and player.vimeo.com/video/ID
const VIMEO_ID_PATTERN = /vimeo\.com\/(?:video\/)?(\d+)/;

/** Maps the API's `source` ("YouTube", "Vimeo", "AWS") to a provider. */
export const getVideoProvider = (source = ""): VideoProvider | null => {
  const normalizedSource = source.trim().toUpperCase();
  return (
    Object.values(VideoProvider).find(
      (provider) => provider === normalizedSource,
    ) ?? null
  );
};

/** Only https links are played — blocks javascript:, data: and http: links */
export const isSafeVideoUrl = (link = ""): boolean => {
  try {
    return new URL(link).protocol === "https:";
  } catch {
    return false;
  }
};

/** Any YouTube link → embeddable player URL (youtube-nocookie sets fewer cookies) */
export const getYoutubeEmbedUrl = (link: string): string | null => {
  const id = link.match(YOUTUBE_ID_PATTERN)?.[1];
  return id
    ? `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`
    : null;
};

/** Any Vimeo link → embeddable player URL (dnt = do not track) */
export const getVimeoEmbedUrl = (link: string): string | null => {
  const id = link.match(VIMEO_ID_PATTERN)?.[1];
  return id ? `https://player.vimeo.com/video/${id}?autoplay=1&dnt=1` : null;
};
